import * as React from 'react';
import { Component } from 'react';
import { ValidationLevel } from 'ui';
import { ModalWrapper } from 'app/components/modal-wrapper/modal-wrapper';
import { MergeCodeProps } from './types';
import { LoadOptions } from 'app/types-shared';
import { CodeSinglePicker } from 'app/area/codetable/common';
import { CodeComplexValue } from 'app/area/shared/codetable/types';
import { replaceTemplateString } from 'app/infrastructure/platform';
import {
  keyCombinationViolation, fieldName, codeId, softConnectionViolation
} from 'app/area/codetable/common/merge-code/constants';
import { canMergeWithCategory } from 'app/area/codetable/common/merge-code/can-merge';
import { validate } from 'app/area/codetable/common/merge-code/validate';
import styles from './merge-code.scss';

export class MergeCodeModal extends Component<MergeCodeProps> {

  public componentDidMount() {
    this.resetAllValidations();
  }

  private resetAllValidations = () => {
    const { resetValidation, validation } = this.props;
    resetValidation(fieldName);
    resetValidation(codeId);
    validation?.[softConnectionViolation] && resetValidation(softConnectionViolation);
    validation?.[keyCombinationViolation] && resetValidation(keyCombinationViolation);
  };

  public render() {

    const { className, mergeCode, metadata, options, fetching, validation, translation,
      onClose, loadOptions, updateMergeCode, deleteCodeItem } = this.props;

    const codeOptions = (options?.[fieldName]?.codes || []) as CodeComplexValue<number>[];
    const defaultValidation = validation?.[fieldName] || validation?.[codeId];
    const includeDisabledLabel = metadata?.features?.disabled && translation.include_disabled;

    const finalValidation = validation?.[softConnectionViolation] || validation?.[keyCombinationViolation]
      ? {
        level: ValidationLevel.error,
        messages: [
          { parameters: {}, level: ValidationLevel.error, message: translation.merge_code_violation_error }
        ]
      } : defaultValidation;

    const uncheckSelectItem = !this.props.mergeCode?.reassignReferencesToCode?.description;

    const handleOnLoadOptions = (id: string, loadOptionsParams: LoadOptions) => {
      loadOptions(id, mergeCode?.codetableId, {
        ...loadOptionsParams,

        includeInactiveCodes: { enabled: loadOptionsParams.includeDisabled },

        ...(canMergeWithCategory(mergeCode.codetableId, mergeCode?.categoryId)
          && { categoryId: mergeCode?.categoryId })
      });
    };

    const handleOnChange = (reassignReferencesToCode: CodeComplexValue<number>) => {
      this.resetAllValidations();
      updateMergeCode({ ...mergeCode, reassignReferencesToCode });
    };

    const handleClose = () => {
      onClose();
      this.resetAllValidations();
      updateMergeCode(undefined);
    };

    const onDone = () => {
      const currentValidation = validate({
        id: mergeCode?.codeId,
        reassignReferencesToCodeId: mergeCode?.reassignReferencesToCode?.value,
        translation
      });

      if (currentValidation) {
        this.props.updateValidation(currentValidation);
        return;
      }
      
      deleteCodeItem(uncheckSelectItem);
    };

    return (<div className={className}>
      <ModalWrapper
        headerTitle={translation.merge_code_title}
        btnTitle={translation.delete}
        btnCancelTitle={translation.cancel}
        onClose={handleClose}
        onDone={onDone}
        closeOnDone={false}
        isCancelDisabled={fetching}
        isDisabled={fetching}
        invertButtonOrder={true}>
        <div className="row">
          <div className="col-12">
            <p className={styles.multilineText}>
              {replaceTemplateString(
                translation.merge_code_subtitle,
                mergeCode?.codeId,
                mergeCode?.codeDescription
              )}
            </p>
            <p className="mt-4">
              {replaceTemplateString(translation.merge_code_replace_info, mergeCode?.replaceInfoText)}
            </p>
          </div>
          <CodeSinglePicker
            id={fieldName}
            label={undefined}
            size={12}
            readOnly={!!fetching}
            valueItem={mergeCode?.[fieldName]}
            searchRequired={mergeCode?.codetableId && metadata?.codetable?.searchRequired}
            options={codeOptions}
            fetchingOptions={options?.[fieldName]?.fetching}
            includeDisabledLabel={includeDisabledLabel}
            uncheckSelectItem={uncheckSelectItem}
            translation={translation}
            validation={finalValidation}
            onLoadOptions={handleOnLoadOptions}
            onChange={handleOnChange} />
        </div>
      </ModalWrapper>
    </div>);
  }
}
